import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Container, Fab, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import Fetching from "../../../Common/Fetching";
import SurveyFormDialog from "./SurveyFormDialog";
import SurveyListItem from "./SurveyListItem";

import { DataTypes } from "../../../../constants";
import msfActions from "../../../../actions/msfActions";
import { getSurveys, isFetching, getUser } from "../../../../reducers";

const SurveyList = () => {
    const dispatch = useDispatch();
    const [surveyDialogOpen, setSurveyDialogOpen] = useState(false);

    useEffect(() => {
        dispatch(msfActions.getSurveys("P-MSF"));
    }, [dispatch]);

    const surveys = useSelector(getSurveys);
    const user = useSelector((state) => getUser(state));

    const fetching = useSelector((state) =>
        isFetching(state, DataTypes.MSF_SURVEY)
    );

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>
                {fetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}
                {surveys?.length > 0 &&
                    surveys.map((data) => (
                        <Grid item xs={12} key={data.uuid}>
                            <SurveyListItem data={data} user={user} />
                        </Grid>
                    ))}
            </Grid>
            <Fab
                color="secondary"
                aria-label="add"
                className="fab"
                onClick={() => setSurveyDialogOpen(true)}
            >
                <AddIcon />
            </Fab>
            {!!surveyDialogOpen && (
                <SurveyFormDialog
                    open
                    onClose={() => setSurveyDialogOpen(false)}
                    scroll="paper"
                />
            )}
        </Container>
    );
};

export default SurveyList;
